import { useDispatch } from 'react-redux'
import { HexagonSizeInput as Input } from 'ui-components'
import { setSize, useSize } from '~map-preview/states/hexagons'

function HexagonSizeInput() {
  const dispatch = useDispatch()
  const size = useSize()

  const handleChange = (event, value) => {
    dispatch(setSize(value))
  }

  return (
    <Input
      value={size}
      onChange={handleChange}
    />
  )
}

export { HexagonSizeInput }
